export default "__VITE_ASSET__BO7ua9I7__"